export const DATA_QUALITY_WORKFLOWS_CATEGORY = 'data_quality_workflows'

export const EVAL_PANTRY_TUNING_CATEGORY = 'eval_pantry_tuning'
export const REVIEW_OUTPUTS_CATEGORY = 'review_outputs'

export const SETTINGS_PANTRY_MATCH_REVIEW_HASH = 'pantry-match-review'
export const SETTINGS_RECIPE_EXTRACTION_REVIEW_HASH = 'recipe-extraction-review'

export const SETTINGS_DATA_QUALITY_HASHES = new Set([
  SETTINGS_PANTRY_MATCH_REVIEW_HASH,
  SETTINGS_RECIPE_EXTRACTION_REVIEW_HASH,
])
